import { vdkHappinessPortalApi } from "./vdk-happiness-portal-api";
import { convertModelToFormData } from "@ui/constants/Helper";
const getCompanies = (query) => {
    return vdkHappinessPortalApi.post("/company/get-paginated", query);
};
const getAll = () => {
    return vdkHappinessPortalApi.get("/company/get-all");
};
const createCompany = async (payload) => {
    const formData = convertModelToFormData(payload);
    return vdkHappinessPortalApi.postForm('/company/create', formData);
};
const updateCompany = async (payload) => {
    const formData = convertModelToFormData(payload);
    return vdkHappinessPortalApi.postForm('/company/update', formData);
};
const getById = (id) => {
    return vdkHappinessPortalApi.get(`/company/get-by-id`, {
        params: { id }
    });
};
const getAllByUser = () => {
    return vdkHappinessPortalApi.get("/company/get-all-by-user");
};
const updateStatus = (command) => {
    return vdkHappinessPortalApi.post("/company/update-status", command);
};
const companyApi = {
    getCompanies,
    getAll,
    updateCompany,
    createCompany,
    getById,
    getAllByUser,
    updateStatus
};
export default companyApi;
